import { fontSizes } from "~/utils/theme";

const gutter = {
  base: 4,
  md: 8,
};
const maxWidth = "80rem";

export const sharedProps = {
  button: {
    md: {
      h: { base: "3rem" },
      fontSize: { base: fontSizes.md, md: fontSizes.lg },
    },
  },
  formLabel: {
    default: {
      fontSize: fontSizes.sm,
    },
  },
  fullBleed: {
    maxW: "unset",
    w: "100%",
  },
  link: {
    hover: {
      decoration: "underline",
    },
  },
  max: {
    content: {
      maxWidth: maxWidth,
      px: gutter,
      w: "100%",
    },
    width: maxWidth,
  },
};
